import debug from 'debug'
import events from 'Store/events'
import Vue from 'vue'
import API from '@/api'
import Channel from 'Store/class/chat/channel'
import ChannelMember from 'Store/class/chat/channel/member'
import Group from 'Store/class/chat/group'
import GroupMember from 'Store/class/chat/group/member'
import DirectMessage from 'Store/class/chat/direct_message'
import SmsMessage from 'Store/class/chat/sms_message'
import User from 'Store/class/chat/user'
import ChatLocalStorage from '@/api/chat'

const dbg = debug('store:chat:mutations:')

export default {
  SET_PAGINATION_DM (state, pagination) {
    state.paginationDm = pagination
  },
  SET_PAGINATION_SMS (state, pagination) {
    state.paginationSms = pagination
  },
  SET_PAGINATION_CHANNELS (state, pagination) {
    state.paginationChannels = pagination
  },
  SET_PAGINATION_GROUPS (state, pagination) {
    state.paginationGroups = pagination
  },
  SELECT_ROOM (state, room) {
    state.roomSelected = room
  },
  SELECT_CHANNEL (state, position) {
    state.channelSelected = position
  },
  SELECT_GROUP (state, position) {
    state.groupSelected = position
  },
  SELECT_DIRECT_MSG (state, position) {
    state.directConversationSelected = position
  },
  SELECT_SMS_MSG (state, position) {
    state.smsSelected = position
  },
  FILTER_SMS (state, smsFilters) {
    state.smsFilters = smsFilters
    ChatLocalStorage.setSmsFilters(smsFilters)
  },
  FILTER_SMS_INIT (state) {
    const smsFilters = ChatLocalStorage.smsFilters()
    if (smsFilters) {
      state.smsFilters = smsFilters
    }
    this.dispatch('chat/SmsFilters/filterClosed', ChatLocalStorage.smsFilterClosed())
    this.dispatch('chat/SmsFilters/filterRead', ChatLocalStorage.smsFilterRead())
    this.dispatch('chat/SmsSortByFilter/init')
  },
  FILTER_DM_INIT (state) {
    this.dispatch('chat/DmFilters/filterClosed', ChatLocalStorage.dmFilterClosed())
    this.dispatch('chat/DmFilters/filterRead', ChatLocalStorage.dmFilterRead())
    this.dispatch('chat/DmSortByFilter/init')
  },
  FILTER_CHANNELS_INIT (state) {
    this.dispatch('chat/ChannelsFilters/filterClosed', ChatLocalStorage.channelsFilterClosed())
    this.dispatch('chat/ChannelsFilters/filterRead', ChatLocalStorage.channelsFilterRead())
    this.dispatch('chat/ChannelsSortByFilter/init')
  },
  FILTER_GROUPS_INIT (state) {
    this.dispatch('chat/GroupsFilters/filterClosed', ChatLocalStorage.groupsFilterClosed())
    this.dispatch('chat/GroupsFilters/filterRead', ChatLocalStorage.groupsFilterRead())
    this.dispatch('chat/GroupsSortByFilter/init')
  },
  DM_NEXT_PAGE (state) {
    state.paginationDm.offset = state.paginationDm.offset + state.dmPageSize
  },
  SMS_NEXT_PAGE (state) {
    state.paginationSms.offset = state.paginationSms.offset + state.smsPageSize
  },
  CHANNELS_NEXT_PAGE (state) {
    state.paginationChannels.offset = state.paginationChannels.offset + state.channelsPageSize
  },
  GROUPS_NEXT_PAGE (state) {
    state.paginationGroups.offset = state.paginationGroups.offset + state.groupsPageSize
  },
  // total unread
  UNREAD (state, unread) {
    state.unread = unread
  },
  REALTIME_API (state, realTimeAPI) {
    state.realTimeAPI = realTimeAPI
  },
  REFRESH_UNREAD (state) {
    const payload = {
      msg: 'method',
      method: 'subscriptions/get',
      id: '42'
    }
    const subscriptions = state.realTimeAPI.callMethod('subscriptions/get', payload)
    const that = this
    let unread = 0
    that.dispatch('chat/setUnread', unread)
    subscriptions.subscribe(
      (data) => {
        data.result.forEach((subscription) => {
          if (subscription.open) {
            unread += subscription.unread
            that.dispatch('chat/setUnread', unread)
          }
        })
      },
      (err) => this.dbg('Failed to get chat user subscriptions: %o', err))
  },
  SET_CHANNEL_LAST_MESSAGE (state, { params, index }) {
    if (params.notification) {
      if (!state.channels[index].lastMessage) {
        Vue.set(state.channels[index], 'lastMessage', {})
      }
      Vue.set(state.channels[index].lastMessage, 'u', params.notification.sender)
      Vue.set(state.channels[index].lastMessage, 'msg', params.notification.message.msg)
      Vue.set(state.channels[index].lastMessage, 'ts', (new Date()).toISOString())
    } else if (params.lastMessage) {
      params.lastMessage.ts = (new Date(params.lastMessage.ts.$date || params.lastMessage.ts)).toISOString()
      Vue.set(state.channels[index], 'lastMessage', params.lastMessage)
    }
  },
  SET_GROUP_LAST_MESSAGE (state, { params, index }) {
    if (params.notification) {
      if (!state.groups[index].lastMessage) {
        Vue.set(state.groups[index], 'lastMessage', {})
      }
      Vue.set(state.groups[index].lastMessage, 'u', params.notification.sender)
      Vue.set(state.groups[index].lastMessage, 'msg', params.notification.message.msg)
      Vue.set(state.groups[index].lastMessage, 'ts', (new Date()).toISOString())
    } else if (params.lastMessage) {
      params.lastMessage.ts = (new Date(params.lastMessage.ts.$date || params.lastMessage.ts)).toISOString()
      Vue.set(state.groups[index], 'lastMessage', params.lastMessage)
    }
  },
  SET_DM_LAST_MESSAGE (state, { params, index }) {
    if (params.notification) {
      if (!state.directConversations[index].lastMessage) {
        Vue.set(state.directConversations[index], 'lastMessage', {})
      }
      Vue.set(state.directConversations[index].lastMessage, 'u', params.notification.sender)
      Vue.set(state.directConversations[index].lastMessage, 'msg', params.notification.message.msg)
      Vue.set(state.directConversations[index].lastMessage, 'ts', (new Date()).toISOString())
    } else if (params.lastMessage) {
      params.lastMessage.ts = (new Date(params.lastMessage.ts.$date || params.lastMessage.ts)).toISOString()
      Vue.set(state.directConversations[index], 'lastMessage', params.lastMessage)
    }
  },
  SET_SMS_LAST_MESSAGE (state, { params, index }) {
    if (params.notification) {
      if (!state.smsConversations[index].lastMessage) {
        Vue.set(state.smsConversations[index], 'lastMessage', {})
      }
      Vue.set(state.smsConversations[index].lastMessage, 'u', params.notification.sender)
      Vue.set(state.smsConversations[index].lastMessage, 'msg', params.notification.message.msg)
      Vue.set(state.smsConversations[index].lastMessage, 'ts', (new Date()).toISOString())
    } else if (params.lastMessage) {
      params.lastMessage.ts = (new Date(params.lastMessage.ts.$date || params.lastMessage.ts)).toISOString()
      Vue.set(state.smsConversations[index], 'lastMessage', params.lastMessage)
    }
  },
  SET_UNREAD_DIRECT_CHAT (state, { unread, index }) {
    if (Number.isInteger(unread)) {
      Vue.set(state.directConversations[index], 'unread', unread)
    }
  },
  SET_UNREAD_SMS_CHAT (state, { unread, index }) {
    if (Number.isInteger(unread)) {
      Vue.set(state.smsConversations[index], 'unread', unread)
    }
  },
  SET_UNREAD_CHANNEL (state, { unread, index }) {
    if (Number.isInteger(unread)) {
      Vue.set(state.channels[index], 'unread', unread)
    }
  },
  SET_UNREAD_GROUP (state, { unread, index }) {
    if (Number.isInteger(unread)) {
      Vue.set(state.groups[index], 'unread', unread)
    }
  },
  SET_OPEN_SMS (state, { open, index }) {
    Vue.set(state.smsConversations[index], 'open', open)
  },
  SET_OPEN_DM (state, { open, index }) {
    Vue.set(state.directConversations[index], 'open', open)
  },
  ADD_CHAT_PRESENCE (state, presence) {
    const newPresence = state.presences.filter(current => current.userId !== presence.userId)
    newPresence.push({ userId: presence.userId, status: presence.status?.toLowerCase(), statusText: presence.statusText ?? '' })

    state.presences = newPresence
  },
  SET_CHAT_PRESENCE_TYPES (state, statuses) {
    const statusTypes = state.presenceTypes
    if (state.presenceTypes.length === 0) {
      statusTypes.push(
        { status: 'online', statusText: '' },
        { status: 'away', statusText: '' },
        { status: 'busy', statusText: '' },
        { status: 'offline', statusText: '' }
      )
    }

    statuses.forEach(status => {
      statusTypes.push({ status: status.status, statusText: status.statusText ?? '' })
    })

    state.presenceTypes = statusTypes
  },
  ADD_CHAT_PRESENCE_TYPE (state, { status, statusText }) {
    const statusTypes = state.presenceTypes
    if (state.presenceTypes.length === 0) {
      statusTypes.push(
        { status: 'online', statusText: '' },
        { status: 'away', statusText: '' },
        { status: 'busy', statusText: '' },
        { status: 'offline', statusText: '' }
      )
    }

    statusTypes.push({ status, statusText: statusText ?? '' })

    state.presenceTypes = statusTypes
  },
  ADD_CHAT_CHANNELS (state, data) {
    const channels = []
    data.forEach(channel => {
      channels.push(new Channel(channel))
    })
    state.channels = channels
  },
  ADD_CHAT_GROUPS (state, data) {
    const groups = []
    data.forEach(group => {
      groups.push(new Group(group))
    })
    state.groups = groups
  },
  ADD_CHAT_CHANNEL_MEMBERS (state, data) {
    const members = []
    data.forEach(member => {
      members.push(new ChannelMember(member))
    })
    state.channelMembers = members
  },
  ADD_CHAT_GROUP_MEMBERS (state, data) {
    const members = []
    data.forEach(member => {
      members.push(new GroupMember(member))
    })
    state.groupMembers = members
  },
  ADD_SMS_DIDS (state, data) {
    const dids = []
    data.forEach(did => {
      dids.push(did)
    })
    state.smsDids = dids
  },
  ADD_DIRECT_CONVERSATION (state, directMessage) {
    state.directConversations.push(new DirectMessage(directMessage))
  },
  ADD_SMS_CONVERSATION (state, smsMessage) {
    state.smsConversations.push(new SmsMessage(smsMessage))
  },
  RESET_DIRECT_CONVERSATION (state) {
    state.directConversations = []
  },
  RESET_SMS_CONVERSATION (state) {
    state.smsConversations = []
  },
  CHANNELS_LOADING (state, loading) {
    state.channelsLoading = loading
  },
  GROUPS_LOADING (state, loading) {
    state.groupsLoading = loading
  },
  SMS_LOADING (state, loading) {
    state.smsConversationsLoading = loading
  },
  DM_LOADING (state, loading) {
    state.directConversationsLoading = loading
  },
  AUTH_ROCKET_USER (state, data) {
    state.authenticatedRocketChatUser = new User(data)
  },
  OPEN_CONVERSATION_DIALOG (state) {
    state.openNewConversationDialog = !state.openNewConversationDialog
  },
  SENDING (state) {
    state.sending = !state.sending
  },
  AVAILABLE_USERS_DRAWER (state) {
    state.availableUsersDrawer = !state.availableUsersDrawer
  },
  CHANNEL_TOGGLE (state, value) {
    state.channelToggle = value
  },
  GROUP_TOGGLE (state, value) {
    state.groupToggle = value
  },
  OPEN_DELETE_DIRECT_CHAT_DIALOG (state) {
    state.openDeleteDirectChatDialog = !state.openDeleteDirectChatDialog
    if (!state.openDeleteDirectChatDialog) {
      this.dispatch('chat/setContextMenuRoomId', null)
    }
  },
  OPEN_MEMBERS_CHANNEL_DIALOG (state) {
    state.openMembersChannelDialog = !state.openMembersChannelDialog
    if (!state.openMembersChannelDialog) {
      this.dispatch('chat/setContextMenuChannel', null)
      state.channelMembers = []
    }
  },
  OPEN_MEMBERS_GROUP_DIALOG (state) {
    state.openMembersGroupDialog = !state.openMembersGroupDialog
    if (!state.openMembersGroupDialog) {
      this.dispatch('chat/setContextMenuGroup', null)
      state.groupMembers = []
    }
  },
  OPEN_CHANNEL_ACTION_DIALOG (state, { options }) {
    state.confirmChannelActionDialog = !state.confirmChannelActionDialog
    if (state.confirmChannelActionDialog) {
      this.dispatch('chat/setContextMenuChannel', options.channel)
      this.dispatch('chat/setContextMenuChannelAction', options.channelAction)
    }
  },
  OPEN_GROUP_ACTION_DIALOG (state, { options }) {
    state.confirmGroupActionDialog = !state.confirmGroupActionDialog
    if (state.confirmGroupActionDialog) {
      this.dispatch('chat/setContextMenuGroup', options.group)
      this.dispatch('chat/setContextMenuGroupAction', options.groupAction)
    }
  },
  CHANNEL_RENAME_DIALOG (state) {
    state.openRenameChannelDialog = !state.openRenameChannelDialog
    if (!state.openRenameChannelDialog) {
      this.dispatch('chat/setContextMenuChannel', null)
    }
  },
  GROUP_RENAME_DIALOG (state) {
    state.openRenameGroupDialog = !state.openRenameGroupDialog
    if (!state.openRenameGroupDialog) {
      this.dispatch('chat/setContextMenuGroup', null)
    }
  },
  CLOSE_CHANNEL_ACTION_DIALOG (state) {
    state.confirmChannelActionDialog = false
    if (!state.confirmChannelActionDialog) {
      if (!state.openMembersChannelDialog) {
        this.dispatch('chat/setContextMenuChannel', null)
      }
      this.dispatch('chat/setContextMenuChannelAction', null)
    }
  },
  CLOSE_GROUP_ACTION_DIALOG (state) {
    state.confirmGroupActionDialog = false
    if (!state.confirmGroupActionDialog) {
      if (!state.openMembersGroupDialog) {
        this.dispatch('chat/setContextMenuGroup', null)
      }
      this.dispatch('chat/setContextMenuGroupAction', null)
    }
  },
  ADD_USERS (state, data) {
    state.users = data
  },
  SET_CONTEXT_MENU_ROOMID (state, roomId) {
    state.contextMenuRoomId = roomId
  },
  SET_CONTEXT_MENU_CHANNEL_ACTION (state, roomAction) {
    state.contextMenuChannelAction = roomAction
  },
  SET_CONTEXT_MENU_CHANNEL (state, channel) {
    state.contextMenuChannel = channel
  },
  SET_CONTEXT_MENU_CHANNEL_MEMBER (state, member) {
    state.contextMenuMember = member
  },
  SET_CONTEXT_MENU_GROUP_ACTION (state, roomAction) {
    state.contextMenuGroupAction = roomAction
  },
  SET_CONTEXT_MENU_GROUP (state, group) {
    state.contextMenuGroup = group
  },
  SET_CONTEXT_MENU_GROUP_MEMBER (state, member) {
    state.contextMenuGroupMember = member
  },
  DELETE_CHANNEL (state) {
    API.deleteChannel(state.contextMenuChannel.id).then(resp => {
      this.dispatch('chat/resetConfirmDialog')
      this.dispatch('chat/getChannels')
    }).catch(err => {
      dbg(err.response)
      events.pubError(API.getException(err) || 'Failed to delete channel')
    })
  },
  JOIN_CHANNEL (state) {
    API.joinChannel(state.contextMenuChannel.id).then(resp => {
      this.dispatch('chat/resetConfirmDialog')
      this.dispatch('chat/getChannels')
    }).catch(err => {
      dbg(err.response)
      events.pubError(API.getException(err) || 'Failed to join channel')
    })
  },
  ADD_MEMBER_TO_CHANNEL (state, userId) {
    API.addMemberToChannel(state.contextMenuChannel.id, userId).then(resp => {
      this.dispatch('chat/getChannelMembers', state.contextMenuChannel.id)
      this.dispatch('chat/getChannels')
    }).catch(err => {
      dbg(err.response)
      events.pubError(API.getException(err) || 'Failed to add member to channel')
    })
  },
  KICK_MEMBER_FROM_CHANNEL (state) {
    API.kickFromChannel(state.contextMenuChannel.id, state.contextMenuMember.id).then(resp => {
      this.dispatch('chat/getChannelMembers', state.contextMenuChannel.id)
      this.dispatch('chat/resetConfirmDialog')
      this.dispatch('chat/getChannels')
    }).catch(err => {
      dbg(err.response)
      events.pubError(API.getException(err) || 'Failed to kick user from channel')
    })
  },
  ADD_OWNER_CHANNEL (state) {
    API.addChannelOwner(state.contextMenuChannel.id, state.contextMenuMember.id).then(resp => {
      this.dispatch('chat/getChannelMembers', state.contextMenuChannel.id)
      this.dispatch('chat/resetConfirmDialog')
      this.dispatch('chat/getChannels')
    }).catch(err => {
      dbg(err.response)
      events.pubError(API.getException(err) || 'Failed to add owner to channel')
    })
  },
  REMOVE_OWNER_CHANNEL (state) {
    API.removeChannelOwner(state.contextMenuChannel.id, state.contextMenuMember.id).then(resp => {
      this.dispatch('chat/getChannelMembers', state.contextMenuChannel.id)
      this.dispatch('chat/resetConfirmDialog')
      this.dispatch('chat/getChannels')
    }).catch(err => {
      dbg(err.response)
      events.pubError(API.getException(err) || 'Failed to remove owner from channel')
    })
  },
  RESTORE_CHANNEL (state) {
    API.restoreChannel(state.contextMenuChannel.id).then(resp => {
      this.dispatch('chat/resetConfirmDialog')
      this.dispatch('chat/getChannels')
    }).catch(err => {
      dbg(err.response)
      events.pubError(API.getException(err) || 'Failed to restore channel')
    })
  },
  OPEN_CHANNEL (state) {
    API.openChannel(state.contextMenuChannel.id).then(resp => {
      this.dispatch('chat/resetConfirmDialog')
      this.dispatch('chat/getChannels')
    }).catch(err => {
      dbg(err.response)
      events.pubError(API.getException(err) || 'Failed to open channel')
    })
  },
  CLOSE_CHANNEL (state) {
    API.closeChannel(state.contextMenuChannel.id).then(resp => {
      this.dispatch('chat/resetConfirmDialog')
      this.dispatch('chat/getChannels')
    }).catch(err => {
      dbg(err.response)
      events.pubError(API.getException(err) || 'Failed to close channel')
    })
  },
  ARCHIVE_CHANNEL (state) {
    API.archiveChannel(state.contextMenuChannel.id).then(resp => {
      this.dispatch('chat/resetConfirmDialog')
      this.dispatch('chat/getChannels')
    }).catch(err => {
      dbg(err.response)
      events.pubError(API.getException(err) || 'Failed to archive channel')
    })
  },
  LEAVE_CHANNEL (state) {
    API.leaveChannel(state.contextMenuChannel.id).then(resp => {
      this.dispatch('chat/resetConfirmDialog')
      this.dispatch('chat/getChannels')
    }).catch(err => {
      dbg(err.response)
      events.pubError(API.getException(err) || 'Failed to leave channel')
    })
  },
  RENAME_CHANNEL (state, name) {
    API.renameChannel(state.contextMenuChannel.id, name).then(resp => {
      this.dispatch('chat/openRenameChannelDialog')
      this.dispatch('chat/getChannels')
    }).catch(err => {
      dbg(err.response)
      events.pubError(API.getException(err) || 'Failed to rename channel')
    })
  },
  DELETE_GROUP (state) {
    API.deleteGroup(state.contextMenuGroup.id).then(resp => {
      this.dispatch('chat/resetGroupConfirmDialog')
      this.dispatch('chat/getGroups')
    }).catch(err => {
      dbg(err.response)
      events.pubError(API.getException(err) || 'Failed to delete group')
    })
  },
  ADD_MEMBER_TO_GROUP (state, userId) {
    API.addMemberToGroup(state.contextMenuGroup.id, userId).then(resp => {
      this.dispatch('chat/getGroupMembers', state.contextMenuGroup.id)
      this.dispatch('chat/getGroups')
    }).catch(err => {
      dbg(err.response)
      events.pubError(API.getException(err) || 'Failed to add member to group')
    })
  },
  KICK_MEMBER_FROM_GROUP (state) {
    API.kickFromGroup(state.contextMenuGroup.id, state.contextMenuGroupMember.id).then(resp => {
      this.dispatch('chat/getGroupMembers', state.contextMenuGroup.id)
      this.dispatch('chat/resetGroupConfirmDialog')
      this.dispatch('chat/getGroups')
    }).catch(err => {
      dbg(err.response)
      events.pubError(API.getException(err) || 'Failed to kick user from group')
    })
  },
  ADD_OWNER_GROUP (state) {
    API.addGroupOwner(state.contextMenuGroup.id, state.contextMenuGroupMember.id).then(resp => {
      this.dispatch('chat/getGroupMembers', state.contextMenuGroup.id)
      this.dispatch('chat/resetGroupConfirmDialog')
      this.dispatch('chat/getGroups')
    }).catch(err => {
      dbg(err.response)
      events.pubError(API.getException(err) || 'Failed to add owner to group')
    })
  },
  REMOVE_OWNER_GROUP (state) {
    API.removeGroupOwner(state.contextMenuGroup.id, state.contextMenuGroupMember.id).then(resp => {
      this.dispatch('chat/getGroupMembers', state.contextMenuGroup.id)
      this.dispatch('chat/resetGroupConfirmDialog')
      this.dispatch('chat/getGroups')
    }).catch(err => {
      dbg(err.response)
      events.pubError(API.getException(err) || 'Failed to remove owner from group')
    })
  },
  RESTORE_GROUP (state) {
    API.restoreGroup(state.contextMenuGroup.id).then(resp => {
      this.dispatch('chat/resetGroupConfirmDialog')
      this.dispatch('chat/getGroups')
    }).catch(err => {
      dbg(err.response)
      events.pubError(API.getException(err) || 'Failed to restore group')
    })
  },
  OPEN_GROUP (state) {
    API.openGroup(state.contextMenuGroup.id).then(resp => {
      this.dispatch('chat/resetGroupConfirmDialog')
      this.dispatch('chat/getGroups')
    }).catch(err => {
      dbg(err.response)
      events.pubError(API.getException(err) || 'Failed to open group')
    })
  },
  CLOSE_GROUP (state) {
    API.closeGroup(state.contextMenuGroup.id).then(resp => {
      this.dispatch('chat/resetGroupConfirmDialog')
      this.dispatch('chat/getGroups')
    }).catch(err => {
      dbg(err.response)
      events.pubError(API.getException(err) || 'Failed to close group')
    })
  },
  ARCHIVE_GROUP (state) {
    API.archiveGroup(state.contextMenuGroup.id).then(resp => {
      this.dispatch('chat/resetGroupConfirmDialog')
      this.dispatch('chat/getGroups')
    }).catch(err => {
      dbg(err.response)
      events.pubError(API.getException(err) || 'Failed to archive group')
    })
  },
  LEAVE_GROUP (state) {
    API.leaveGroup(state.contextMenuGroup.id).then(resp => {
      this.dispatch('chat/resetGroupConfirmDialog')
      this.dispatch('chat/getGroups')
    }).catch(err => {
      dbg(err.response)
      events.pubError(API.getException(err) || 'Failed to leave group')
    })
  },
  RENAME_GROUP (state, name) {
    API.renameGroup(state.contextMenuGroup.id, name).then(resp => {
      this.dispatch('chat/openRenameGroupDialog')
      this.dispatch('chat/getGroups')
    }).catch(err => {
      dbg(err.response)
      events.pubError(API.getException(err) || 'Failed to rename group')
    })
  },
  DELETE_DIRECT_CHAT (state) {
    API.closeDirectChat(state.contextMenuRoomId).then(resp => {
      this.dispatch('chat/resetDeleteDirectChatDialog')
      this.dispatch('chat/getDirectMessages')
      this.dispatch('chat/getSmsMessages')
    }).catch(err => {
      dbg(err.response)
      events.pubError(API.getException(err) || 'Failed to delete conversation')
    })
  },
  NEW_CONVERSATION (state, openNewConversationDialog) {
    state.openNewConversationDialog = openNewConversationDialog
  }
}
